import { ErrorScreen } from '@paysense-india-services/elevate-web'

import { getImageUrl } from '@/constants/images'

const ErrorPage = ({ title, description, onButtonClick, buttonText, isButtonLoading }) => {
  const ErrorIcon = () => {
    return <img alt='Page error' height={190} src={getImageUrl('error')} width={234} />
  }

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick()
    } else {
      window.location.reload()
    }
  }
  return (
    <ErrorScreen
      buttonText={buttonText}
      description={description}
      ErrorImage={<ErrorIcon />}
      isLoading={isButtonLoading}
      onButtonClick={handleButtonClick}
      title={title}
    />
  )
}

export default ErrorPage
